const en = {
  // Login Page
  login: {
    title: 'MedRahi',
    subtitle: 'Connecting patients with trusted Indian care',
    emailLabel: 'Email',
    emailPlaceholder: 'you@example.com',
    passwordLabel: 'Password',
    passwordPlaceholder: '••••••••',
    signInButton: 'Sign In',
    signingIn: 'Signing in...',
    noAccount: "Don't have an account?",
    signUp: 'Sign up',
  },
  
  // Register Page
  register: {
    title: 'Join MedRahi',
    subtitle: 'Create your account to get started',
    fullNameLabel: 'Full Name',
    emailLabel: 'Email',
    passwordLabel: 'Password',
    roleLabel: 'I am a',
    rolePatient: 'Patient',
    roleDoctor: 'Doctor',
    roleHospital: 'Hospital',
    countryLabel: 'Country',
    countryPlaceholder: 'Your home country',
    phoneLabel: 'Phone (Optional)',
    createAccountButton: 'Create Account',
    creatingAccount: 'Creating account...',
    haveAccount: 'Already have an account?',
    signIn: 'Sign in',
  },
  
  // Navigation
  nav: {
    treatments: 'Treatments',
    doctors: 'Doctors',
    hospitals: 'Hospitals',
    services: 'Services',
    wellness: 'Wellness',
    medicalVisa: 'Medical Visa',
    signIn: 'Sign In',
    getStarted: 'Get Started',
    backToHome: 'Back to Home',
  },
  
  // Services Menu
  servicesMenu: {
    airportPickup: 'Airport Pickup & Drop',
    languageInterpreter: 'Language Interpreter',
    surroundingTours: 'Free Surrounding Tours',
    nursingCare: 'Nursing Care Support',
    physiotherapist: 'Physiotherapist',
    travelAccommodation: 'Travel & Accommodation',
    videoConsultations: 'Video Consultations',
  },
  
  // Landing Page
  landing: {
    heroTag: 'Trusted by 10,000+ International Patients',
    heroTitle1: 'Experience',
    heroTitle2: 'World-Class',
    heroTitle3: 'Healthcare in India',
    heroSubtitle: 'Connect with India\'s finest doctors and hospitals. Get affordable, high-quality medical treatment with transparent pricing and personalized care.',
    ctaStart: 'Start Your Journey',
    ctaExplore: 'Explore Portal',
    isoCertified: 'ISO Certified',
    nabhAccredited: 'NABH Accredited',
    jciStandards: 'JCI Standards',
    platformHighlights: 'Platform Highlights',
    realTimeStats: 'Real-time statistics',
    activeNow: 'Active Now',
    verifiedDoctors: 'Verified Doctors',
    partnerHospitals: 'Partner Hospitals',
    successRate: 'Success Rate',
    patientRating: 'Patient Rating',
    patientsTreated: 'patients treated this month',
    
    // Features Section
    whyChoose: 'Why Choose MedRahi',
    featuresTitle: 'Healthcare Excellence Meets Indian Hospitality',
    featuresSubtitle: 'Experience the perfect blend of cutting-edge medical technology and traditional Indian warmth',
    
    features: {
      transparentPricing: {
        title: 'Transparent Pricing',
        desc: 'Compare quotes from multiple hospitals. No hidden costs. Save up to 70% compared to Western countries.',
      },
      worldClassFacilities: {
        title: 'World-Class Facilities',
        desc: 'Access JCI-accredited hospitals with state-of-the-art technology and international standards.',
      },
      verifiedSpecialists: {
        title: 'Verified Specialists',
        desc: 'Connect with board-certified doctors trained internationally with decades of experience.',
      },
      securePrivate: {
        title: 'Secure & Private',
        desc: 'Bank-level encryption for your medical records. HIPAA compliant data protection.',
      },
      endToEndSupport: {
        title: 'End-to-End Support',
        desc: 'From visa assistance to post-treatment care. We handle everything for your comfort.',
      },
      quickResponse: {
        title: 'Quick Response',
        desc: 'Get quotes within 24 hours. Real-time messaging with doctors. Instant appointments.',
      },
    },
    
    // How It Works
    yourJourney: 'Your Journey',
    howItWorksTitle: 'Simple Steps to World-Class Care',
    howItWorksSubtitle: 'From inquiry to recovery, we\'re with you every step',
    steps: {
      step1: { title: 'Submit Request', desc: 'Tell us about your condition and medical needs' },
      step2: { title: 'Compare Quotes', desc: 'Receive detailed quotes from verified doctors' },
      step3: { title: 'Plan Treatment', desc: 'Choose your doctor and schedule appointments' },
      step4: { title: 'Get Treated', desc: 'Receive care and enjoy your recovery in India' },
    },
    startJourney: 'Start Your Treatment Journey',
    
    // Specializations
    popularSpecializations: 'Popular Treatment Specializations',
    indiaExpertise: 'India\'s expertise spans across all medical fields',
    specializations: {
      cardiology: 'Cardiology',
      orthopedics: 'Orthopedics',
      oncology: 'Oncology',
      fertility: 'Fertility',
      dental: 'Dental',
      cosmetic: 'Cosmetic',
    },
    
    // For Doctors & Hospitals
    forDoctors: 'For Doctors',
    forDoctorsDesc: 'Join India\'s leading medical tourism platform and connect with international patients seeking your expertise.',
    forHospitals: 'For Hospitals',
    forHospitalsDesc: 'Partner with MedRahi to attract international patients and showcase your world-class facilities.',
    registerAsDoctor: 'Register as Doctor',
    registerAsHospital: 'Register as Hospital',
    
    doctorBenefits: [
      'Expand your practice globally',
      'Verified patient inquiries',
      'Transparent pricing system',
      'Dedicated support team',
      'Grow your reputation',
    ],
    hospitalBenefits: [
      'Increase international footfall',
      'Showcase your infrastructure',
      'Manage doctors efficiently',
      'Real-time analytics',
      'Marketing support',
    ],
    
    // CTA Section
    ctaTitle: 'Ready to Experience Indian Healthcare?',
    ctaSubtitle: 'Join thousands of satisfied patients who chose India for their medical treatment',
    getStartedNow: 'Get Started Now',
    
    // Footer
    healthcareWithoutBorders: 'Healthcare Without Borders',
    footerDesc: 'Connecting international patients with India\'s finest healthcare professionals since 2024.',
    quickLinks: 'Quick Links',
    contactUs: 'Contact Us',
    copyright: '© 2024 MedRahi. All rights reserved. Made with ❤️ in India',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    cookiePolicy: 'Cookie Policy',
  },
  
  // Service Pages Common
  services: {
    enquireNow: 'Enquire Now - Get a Free Quote',
    responseTime: 'Response within 24 hours',
    whatsIncluded: 'What\'s Included',
    
    // Enquiry Form
    enquiryForm: {
      fullName: 'Full Name',
      email: 'Email',
      phone: 'Phone',
      country: 'Country',
      countryPlaceholder: 'Your home country',
      additionalRequirements: 'Additional Requirements',
      additionalPlaceholder: 'Tell us more about your needs...',
      cancel: 'Cancel',
      submit: 'Submit Enquiry',
      successMessage: 'Enquiry submitted successfully! Our team will contact you within 24 hours.',
    },
    
    // Airport Pickup
    airportPickup: {
      title: 'Airport Pickup & Drop Service',
      subtitle: 'Hassle-free airport transfers for your medical journey. Safe, reliable, and comfortable transportation.',
      mainTitle: 'Welcome to Stress-Free Travel',
      mainDesc1: 'Arriving in a new country for medical treatment can be overwhelming. Our dedicated airport pickup and drop service ensures you start and end your medical journey with comfort and peace of mind. We understand that when you\'re traveling for healthcare, the last thing you need is transportation stress.',
      mainDesc2: 'Our professional drivers will meet you at the airport with a personalized welcome sign, assist with your luggage, and transport you safely to your accommodation or hospital. We monitor flight schedules to ensure punctual pickups, even if your flight is delayed.',
      features: {
        availability: { title: '24/7 Availability', desc: 'Round-the-clock service for early morning or late night flights. We\'re always ready when you need us.' },
        safe: { title: 'Safe & Reliable', desc: 'Experienced, licensed drivers with clean vehicles. Your safety and comfort are our top priorities.' },
        doorToDoor: { title: 'Door-to-Door Service', desc: 'Direct transportation from airport to hotel, hospital, or any location in the city.' },
        flightMonitoring: { title: 'Flight Monitoring', desc: 'We track your flight status to adjust pickup times for delays or early arrivals.' },
      },
      included: [
        'Meet and greet at airport arrivals with name board',
        'Assistance with luggage and airport navigation',
        'Comfortable, air-conditioned vehicles',
        'English-speaking drivers familiar with hospital routes',
        'Wheelchair accessible vehicles available upon request',
        'Complimentary bottled water',
        'Mobile charging points in vehicle',
        'Free waiting time for flight delays',
      ],
      vehicleOptions: 'Vehicle Options',
      sedan: { title: 'Sedan', desc: 'For 1-2 passengers', features: ['Comfortable seating', '2 large suitcases', 'AC & music system'] },
      suv: { title: 'SUV', desc: 'For 3-4 passengers', features: ['Spacious interior', '4 large suitcases', 'Extra legroom'] },
      minivan: { title: 'Minivan', desc: 'For 5-7 passengers', features: ['Family-friendly', '6+ large suitcases', 'Wheelchair accessible'] },
      airportsCovered: 'Major Airports We Cover',
    },
    
    // Language Interpreter
    languageInterpreter: {
      title: 'Language Interpreter & Translator Services',
      subtitle: 'Bridge the communication gap during your medical journey with our professional multilingual interpreters.',
      mainTitle: 'Clear Communication for Better Healthcare',
      mainDesc1: 'When it comes to your health, every word matters. Our professional medical interpreters ensure that nothing gets lost in translation during your consultations, procedures, and hospital stays. We understand that clear communication between you and your medical team is essential for the best treatment outcomes.',
      mainDesc2: 'Our interpreters are not just language experts – they are trained in medical terminology and understand the healthcare context. They accompany you to all appointments, help explain diagnoses, treatment options, and medication instructions, ensuring you\'re fully informed every step of the way.',
      features: {
        languages: { title: '20+ Languages Available', desc: 'Arabic, Russian, French, German, Spanish, Mandarin, Japanese, Korean, Portuguese, Swahili, and many more.' },
        medical: { title: 'Medical Terminology Experts', desc: 'All interpreters are trained in medical vocabulary and healthcare protocols for accurate communication.' },
        options: { title: 'In-Person & Remote Options', desc: 'Choose between physical accompaniment or video/phone interpretation based on your preference.' },
        documents: { title: 'Document Translation', desc: 'Translation of medical reports, prescriptions, discharge summaries, and other essential documents.' },
      },
      servicesInclude: 'Our Interpretation Services Include',
      servicesList: [
        'Doctor consultation interpretation',
        'Surgery and procedure explanations',
        'Medication and aftercare instructions',
        'Hospital admission assistance',
        'Insurance and billing support',
        'Medical report translation',
        'Prescription translation',
        'Emergency on-call support',
        'Video consultation interpretation',
        'Pharmacy and medication guidance',
      ],
      languagesTitle: 'Languages We Support',
      languagesList: [
        'Arabic', 'Russian', 'French', 'German', 'Spanish', 'Mandarin', 
        'Japanese', 'Korean', 'Portuguese', 'Swahili', 'Turkish', 'Persian',
        'Bengali', 'Urdu', 'Indonesian', 'Vietnamese', 'Thai', 'Italian',
        'Dutch', 'Polish'
      ],
      languagesNote: 'Don\'t see your language? Contact us – we can arrange interpreters for most languages.',
    },
    
    // Surrounding Tours
    surroundingTours: {
      title: 'Free Surrounding Tours',
      subtitle: 'Make the most of your medical trip with complimentary guided tours to nearby attractions during your recovery.',
      mainTitle: 'Healing Through Exploration',
      mainDesc1: 'Recovery isn\'t just about medical treatment – it\'s about rejuvenating your mind and spirit too. We believe that experiencing the rich culture and natural beauty of India can be a powerful part of your healing journey. That\'s why we offer complimentary guided tours to nearby attractions during your recovery period.',
      mainDesc2: 'Whether you\'re interested in historical monuments, serene temples, vibrant markets, or peaceful gardens, our local guides will introduce you to the wonders of India. All tours are designed with your medical condition in mind, ensuring comfortable pacing and accessibility.',
      features: {
        customized: { title: 'Customized Itineraries', desc: 'Tours tailored to your interests, energy levels, and medical needs.' },
        transport: { title: 'Comfortable Transport', desc: 'Air-conditioned vehicles with medical-friendly seating and accessibility options.' },
        flexible: { title: 'Flexible Scheduling', desc: 'Tours arranged around your treatment schedule and doctor\'s recommendations.' },
        guides: { title: 'Expert Local Guides', desc: 'Knowledgeable guides who share fascinating stories and insights about each destination.' },
      },
      popularTours: 'Popular Tour Destinations',
      toursList: [
        'Taj Mahal - Agra (Day trip from Delhi)',
        'Gateway of India & Marine Drive - Mumbai',
        'Qutub Minar & India Gate - Delhi',
        'Elephant Caves - Mumbai',
        'Jaipur Pink City Tour',
        'Mysore Palace - Karnataka',
        'Kerala Backwaters',
        'Local Temple & Market Tours',
      ],
      typesTitle: 'Tour Package Options',
      types: {
        halfDay: { title: 'Half Day Tour', desc: '4-5 hours', features: ['Local attractions', 'Light refreshments', 'AC transport'] },
        fullDay: { title: 'Full Day Tour', desc: '8-10 hours', features: ['Multiple destinations', 'Lunch included', 'Flexible pace'] },
        multiDay: { title: 'Multi-Day Tour', desc: '2-3 days', features: ['Accommodation included', 'All meals', 'Comprehensive itinerary'] },
      },
    },
    
    // Nursing Care
    nursingCare: {
      title: 'Nursing Care Support',
      subtitle: 'Professional nursing care at your accommodation for a comfortable and safe recovery experience.',
      mainTitle: 'Compassionate Care, Wherever You Stay',
      mainDesc1: 'Recovery doesn\'t end when you leave the hospital. Our professional nursing care support brings hospital-quality medical attention right to your hotel room or homestay. Our registered nurses are experienced in post-operative care, medication management, and patient monitoring, ensuring your recovery progresses smoothly.',
      mainDesc2: 'Whether you need assistance with wound care, IV management, physiotherapy exercises, or simply need someone to monitor your vital signs and medication schedule, our nurses provide attentive, compassionate care tailored to your specific needs. They also serve as a vital link between you and your medical team, reporting any concerns promptly.',
      features: {
        roundClock: { title: '24/7 Availability', desc: 'Round-the-clock nursing support whenever you need it, day or night.' },
        certified: { title: 'Certified Nurses', desc: 'All our nurses are registered professionals with ICU, surgical, and home care experience.' },
        homeHotel: { title: 'Home & Hotel Care', desc: 'Nursing visits at your hotel, serviced apartment, or any accommodation of your choice.' },
        personalized: { title: 'Personalized Care', desc: 'Care plans tailored to your specific medical needs and recovery goals.' },
      },
      servicesTitle: 'Our Nursing Services Include',
      servicesList: [
        'Vital signs monitoring (BP, temperature, pulse, oxygen)',
        'Medication administration and management',
        'Wound care and dressing changes',
        'IV therapy and injections',
        'Catheter care and management',
        'Post-surgical care and monitoring',
        'Diabetes management and insulin administration',
        'Pain management support',
        'Assistance with mobility and daily activities',
        'Diet and nutrition monitoring',
        'Coordination with your doctors',
        'Medical emergency first response',
      ],
      packagesTitle: 'Care Package Options',
      packages: {
        basic: { title: 'Hourly Visits', desc: 'Scheduled visits for specific care tasks', features: ['1-4 hour sessions', 'Ideal for wound care', 'Medication assistance'] },
        standard: { title: 'Day Care', desc: '8-12 hour nursing support', features: ['Daytime monitoring', 'Multiple care tasks', 'Activity assistance'] },
        premium: { title: '24/7 Care', desc: 'Round-the-clock nursing', features: ['Continuous monitoring', 'Night care included', 'Comprehensive support'] },
      },
    },
    
    // Physiotherapist
    physiotherapist: {
      title: 'Physiotherapist Arrangements',
      subtitle: 'Expert physiotherapy services to accelerate your recovery and restore mobility.',
      mainTitle: 'Restore Mobility, Rebuild Strength',
      mainDesc1: 'Physiotherapy is a crucial component of recovery for many medical procedures, especially orthopedic surgeries, joint replacements, and neurological treatments. Our network of certified physiotherapists specializes in rehabilitation and recovery, helping you regain strength, mobility, and independence.',
      mainDesc2: 'Whether you need in-room sessions at your accommodation or visits to a nearby physiotherapy center, we arrange personalized treatment plans designed in consultation with your surgeon or treating doctor. Our physiotherapists use modern techniques and equipment to ensure optimal recovery outcomes.',
      features: {
        certified: { title: 'Certified Specialists', desc: 'Licensed physiotherapists with expertise in post-surgical rehabilitation and sports medicine.' },
        personalized: { title: 'Personalized Programs', desc: 'Treatment plans tailored to your specific surgery, condition, and recovery goals.' },
        equipment: { title: 'Modern Equipment', desc: 'Access to advanced physiotherapy equipment and techniques for effective rehabilitation.' },
        flexible: { title: 'Flexible Sessions', desc: 'In-room visits, clinic sessions, or hybrid arrangements based on your preference.' },
      },
      treatmentsTitle: 'Our Physiotherapy Specializations',
      treatmentsList: [
        'Post knee replacement rehabilitation',
        'Hip replacement recovery',
        'Spine surgery rehabilitation',
        'Shoulder and rotator cuff therapy',
        'Cardiac rehabilitation',
        'Neurological physiotherapy',
        'Sports injury recovery',
        'Stroke rehabilitation',
        'Pre-surgical strengthening',
        'Balance and fall prevention',
        'Pain management therapy',
        'Range of motion exercises',
      ],
      sessionsTitle: 'Session Package Options',
      sessions: {
        single: { title: 'Single Session', desc: 'One-time visit', features: ['60-minute session', 'Initial assessment', 'Exercise guidance'] },
        package: { title: 'Package (10 Sessions)', desc: 'Best value', features: ['10 sessions', 'Progress tracking', 'Customized plan'] },
        intensive: { title: 'Intensive Program', desc: 'Daily sessions', features: ['Daily therapy', '2-4 week program', 'Comprehensive rehab'] },
      },
    },
    
    // Travel & Accommodation
    travelAccommodation: {
      title: 'Travel & Accommodation Arrangements',
      subtitle: 'Complete travel planning and comfortable stays near your hospital – all arranged for you.',
      mainTitle: 'Your Comfort is Our Priority',
      mainDesc1: 'Planning a medical trip involves more than just choosing a hospital. From flight bookings to finding the perfect place to stay, we handle all your travel logistics so you can focus entirely on your health. Our team ensures your accommodation is comfortable, conveniently located near your hospital, and equipped with everything you need during your recovery.',
      mainDesc2: 'Whether you prefer a budget-friendly guesthouse, a comfortable hotel, or a fully-serviced apartment for longer stays, we have partnerships with accommodations that understand the needs of medical travelers. Many offer special amenities like room service, dietary accommodations, and quiet environments perfect for recovery.',
      features: {
        proximity: { title: 'Hospital Proximity', desc: 'Accommodations within easy reach of hospitals, pharmacies, and essential services.' },
        amenities: { title: 'Medical-Friendly Amenities', desc: 'Room service, dietary accommodations, and quiet environments perfect for recovery.' },
        meals: { title: 'Meal Options', desc: 'Dietary requirements communicated and catered to, with healthy meal options available.' },
        safety: { title: 'Safety & Security', desc: 'All accommodations inspected for cleanliness, safety, and accessibility.' },
      },
      servicesTitle: 'What We Arrange For You',
      servicesList: [
        'Flight booking assistance',
        'Medical visa guidance',
        'Accommodation selection and booking',
        'Airport pickup coordination',
        'Local SIM card arrangement',
        'Currency exchange guidance',
        'Local area orientation',
        'Emergency contact setup',
        'Extension of stay arrangements',
        'Companion accommodation',
        'Dietary requirement communication',
        'Hospital proximity mapping',
      ],
      typesTitle: 'Accommodation Options',
      types: {
        budget: { title: 'Budget Guesthouses', desc: 'Affordable & clean', features: ['Basic amenities', 'Near hospitals', 'Home-cooked meals'] },
        comfort: { title: 'Hotels (3-5 Star)', desc: 'Premium comfort', features: ['Room service 24/7', 'Concierge assistance', 'Housekeeping daily'] },
        luxury: { title: 'Serviced Apartments', desc: 'Home away from home', features: ['Full kitchen', 'Living space', 'Long-stay discounts'] },
      },
    },
    
    // Video Consultations
    videoConsultations: {
      title: 'Video Consultations',
      subtitle: 'Connect with India\'s top specialists from anywhere in the world through secure video calls.',
      mainTitle: 'Expert Medical Advice, Wherever You Are',
      mainDesc1: 'Not sure if you need to travel to India for treatment? Start your journey with a video consultation. Our secure telehealth platform connects you with India\'s leading specialists, allowing you to discuss your condition, get second opinions, and understand your treatment options – all from the comfort of your home.',
      mainDesc2: 'Video consultations are perfect for initial assessments, treatment planning, second opinions, and post-treatment follow-ups. Share your medical reports digitally, and our specialists will review them thoroughly before your scheduled call. After the consultation, you\'ll receive a detailed written summary and recommendations.',
      features: {
        secure: { title: 'HIPAA Compliant', desc: 'End-to-end encrypted video calls ensuring your medical information remains private.' },
        convenient: { title: 'Convenient Scheduling', desc: 'Early morning or late evening slots available to accommodate different time zones.' },
        global: { title: 'Global Accessibility', desc: 'Connect from any country, any timezone. We schedule appointments that work for you.' },
        easy: { title: 'Easy to Use', desc: 'Simple platform that works on your phone, tablet, or computer. No special software needed.' },
      },
      included: [
        'Pre-consultation document review',
        '30-60 minute video call with specialist',
        'Written consultation summary',
        'Treatment recommendations',
        'Follow-up Q&A support',
        'Medical report interpretation',
        'Second opinion documentation',
        'Cost estimates for treatment',
      ],
      typesTitle: 'Consultation Types',
      types: {
        initial: { title: 'Initial Assessment', desc: 'First consultation', features: ['Condition review', 'Treatment options', 'Cost estimates'] },
        followUp: { title: 'Follow-Up', desc: 'Progress review', features: ['Treatment progress', 'Adjustments', 'Next steps'] },
        secondOpinion: { title: 'Second Opinion', desc: 'Expert review', features: ['Independent assessment', 'Alternative options', 'Detailed report'] },
      },
      specialtiesTitle: 'Specialties Available',
      specialtiesList: [
        'Cardiology', 'Oncology', 'Orthopedics', 'Neurology', 'Gastroenterology',
        'Urology', 'Gynecology', 'ENT', 'Dermatology', 'Pulmonology',
        'Nephrology', 'Endocrinology', 'Ophthalmology', 'Plastic Surgery'
      ],
    },
  },
  
  // Treatments Page
  treatments: {
    heroTitle: 'World-Class Medical',
    heroTitleHighlight: 'Treatments',
    heroSubtitle: 'India offers advanced medical treatments at a fraction of the cost. Explore our comprehensive range of specialties and procedures.',
    jciAccredited: 'JCI Accredited Hospitals',
    costSavings: '60-80% Cost Savings',
    expertSurgeons: 'Expert Surgeons',
    filters: 'Filters',
    showing: 'Showing',
    treatmentsCount: 'treatments',
    commonProcedures: 'Common Procedures',
    learnMore: 'Learn More',
    savingsCompared: 'savings compared to US',
  },
  
  // Doctors Page
  doctors: {
    heroTitle: "Connect with India's",
    heroTitleHighlight: 'Top Doctors',
    heroSubtitle: 'Highly qualified specialists with international training and years of experience in their fields.',
    filterDoctors: 'Filter Doctors',
    hideFilters: 'Hide Filters',
    showFilters: 'Show Filters',
    city: 'City',
    allCities: 'All Cities',
    state: 'State',
    allStates: 'All States',
    specialization: 'Specialization',
    allSpecializations: 'All Specializations',
    experience: 'Experience',
    anyExperience: 'Any Experience',
    yearsPlus: 'years+',
    showing: 'Showing',
    doctorsCount: 'doctors',
    yearsExperience: 'years experience',
    viewProfile: 'View Profile',
    requestAppointment: 'Request Appointment',
    noResults: 'No doctors found matching your criteria',
    tryAdjusting: 'Try adjusting your filters to see more results',
    clearFilters: 'Clear Filters',
  },
  
  // Hospitals Page
  hospitals: {
    heroTitle: "India's Premier",
    heroTitleHighlight: 'Hospitals',
    heroSubtitle: 'JCI accredited hospitals with world-class infrastructure, cutting-edge technology, and exceptional patient care across 9 states.',
    hospitalsCount: 'Hospitals',
    jciAccredited: 'JCI Accredited',
    expertTeams: 'Expert Medical Teams',
    filters: 'Filters',
    showing: 'Showing',
    hospitalsCountLabel: 'hospitals',
    bedCapacity: 'Bed Capacity',
    viewHospital: 'View Hospital',
    specialties: 'Specialties',
    accreditations: 'Accreditations',
  },
  
  // Wellness Page
  wellness: {
    heroTitle: 'Holistic Wellness &',
    heroTitleHighlight: 'Recovery',
    heroSubtitle: 'Combine world-class medical treatment with India\'s ancient wellness traditions for complete mind, body, and spirit healing.',
    ayurveda: 'Ayurveda',
    yoga: 'Yoga & Meditation',
    naturopathy: 'Naturopathy',
    spa: 'Spa & Rejuvenation',
    whyChoose: 'Why Choose India for Wellness',
    healingTraditions: 'India has a 5,000-year tradition of holistic healing through Ayurveda, yoga, and naturopathy.',
    integratedCare: 'Our wellness programs are designed to complement your medical treatment and accelerate recovery.',
  },
  
  // Medical Visa Page
  medicalVisa: {
    heroTitle: 'Medical Visa',
    heroTitleHighlight: 'Assistance',
    heroSubtitle: 'We guide you through the entire medical visa process, making your healthcare journey to India smooth and hassle-free.',
    whatIs: 'What is a Medical Visa?',
    whatIsDesc: 'A medical visa (M-Visa) is issued to foreign nationals seeking medical treatment in India. It allows multiple entries and is valid for up to one year.',
    eligibility: 'Eligibility',
    eligibilityDesc: 'Patients seeking treatment at recognized Indian hospitals',
    validity: 'Validity',
    validityDesc: 'Up to 1 year or 3 times the treatment duration',
    entries: 'Entries',
    entriesDesc: 'Triple entry, extendable',
    attendants: 'Attendants',
    attendantsDesc: 'Up to 2 medical attendant visas (MX-Visa)',
    documentsRequired: 'Documents Required',
    howWeHelp: 'How We Help',
  },
};

export default en;
